export default {
      id: "ic_default_jockey-usage",
      viewBox: "0 0 16 17",
      url: "/" + "images/icons.3.109.2.svg#ic_default_jockey-usage",
      toString: function () {
        return this.url;
      }
    }